import { render, staticRenderFns } from "./colourManage.vue?vue&type=template&id=515c8f9a&scoped=true&"
import script from "./colourManage.vue?vue&type=script&lang=js&"
export * from "./colourManage.vue?vue&type=script&lang=js&"
import style0 from "./colourManage.vue?vue&type=style&index=0&id=515c8f9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c8f9a",
  null
  
)

export default component.exports